import React from 'react';

type ButtonTheme = 'primary' | 'secondary' | 'white' | 'black' | 'danger';
type ButtonSize = 's' | 'm' | 'l' | 'xl';

interface IconButtonProps {
    theme?: ButtonTheme;
    size?: ButtonSize;
    onClick: () => void;
    icon: React.ReactElement;
    hoverIcon?: React.ReactElement;
    isLoading?: boolean;
    disabled?: boolean;
}



const IconButton: React.FC<IconButtonProps> = ({
    theme = 'black',
    size = 'm',
    onClick,
    icon,
    hoverIcon,
    isLoading = false,
    disabled = false,
}) => {

    const themeClasses = {
        primary: `text-primary border-primary ${hoverIcon ? '' : 'hover:text-primary-600'}`,
        secondary: `text-secondary border-secondary ${hoverIcon ? '' : 'hover:text-gray-500'}`,
        white: `text-white border-white ${hoverIcon ? '' : 'hover:text-gray-200'}`,
        black: `text-black border-black ${hoverIcon ? '' : 'hover:text-gray-500'}`,
        danger: `text-red-500 border-red-500 ${hoverIcon ? '' : 'hover:text-red-700'}`,
    };

    const sizeClasses = {
        s: "h-5 w-5",
        m: "h-6 w-6",
        l: "h-8 w-8",
        xl: "h-10 w-10",
    };
    const themeClass = themeClasses[theme];
    const sizeClass = sizeClasses[size];
    const disabledClasses = disabled ? "opacity-50 cursor-not-allowed" : "";

    // Clone the icon element to apply the size class
    const iconWithSize = React.cloneElement(icon, {
        className: `${sizeClass} ${icon.props.className || ''}`.trim(),
    });

    const [isHovered, setIsHovered] = React.useState(false);

    return (
        <div
            className="flex flex-col items-center"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <button
                onClick={onClick}
                disabled={disabled || isLoading}
                className={`flex items-center justify-center rounded-full ${themeClass} ${disabledClasses} transition-all duration-200`}
            >
                <div className='flex flex-col items-center'>
                    {isLoading ? (
                        // Loading icon
                        <div className={`animate-spin rounded-full h-5 w-5 border-b-2 ${themeClasses[theme]}`} />
                    ) : isHovered && hoverIcon ? (
                        React.cloneElement(hoverIcon, {
                            className: `${sizeClass} ${hoverIcon.props.className || ''}`.trim(),
                        })
                    ) : (
                        iconWithSize
                    )}
                </div>
            </button>
        </div>
    );
};

export default IconButton;